import React from 'react';

import SegmentDashboardShell from '../../dashboard/SegmentDashboardShell';

export default function StartupDashboardPage() {
  return <SegmentDashboardShell variant="startup" />;
}
